var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { AccordionItemContext } from '../AccordionItemContext';
const LinearGradient = styled.div `
  height: 8px;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.03) 0%,
    rgba(249, 249, 249, 0.03) 100%
  );
  float: left;
  width: 100%;
`;
const AccordionItemBackground = styled.div `
  background-color: ${({ theme: { colors } }) => colors.white};
`;
const InnerAccordionItemBox = styled.div `
  ${({ theme: { space, iconSize }, $disableContainer }) => `
    padding: ${space.md} calc(${space.xs} + ${iconSize.xl});
    
    ${$disableContainer ? `padding-top: 0;` : ``}
  `}
`;
const StyledAccordionItemBoxWrapper = styled.div `
  border: none;

  &:focus {
    outline: none;
  }

  ${({ disableContainer, theme: { colors } }) => `
    ${!disableContainer ? `border-bottom: 1px solid ${colors['slate-2']};` : ``}
  `}
`;
const AccordionItemBox = (_a) => {
    var { disableContainer = false, children } = _a, others = __rest(_a, ["disableContainer", "children"]);
    if (!disableContainer) {
        return (React.createElement(StyledAccordionItemBoxWrapper, Object.assign({ disableContainer: disableContainer }, others),
            React.createElement(AccordionItemBackground, null,
                React.createElement(LinearGradient, null),
                React.createElement(InnerAccordionItemBox, null, children))));
    }
    return (React.createElement(InnerAccordionItemBox, Object.assign({ "$disableContainer": disableContainer }, others), children));
};
const StyledAccordionItemBox = styled(AccordionItemBox) `
  ${({ theme: { screenReader: { srOnlyInline }, }, $screenReaderOnly, }) => $screenReaderOnly
    ? `
        ${srOnlyInline}
        visibility: hidden;
      `
    : ''}
`;
export const AccordionItemPanelBase = (_a) => {
    var { panel, isExpanded, closePanel, disableContainer = false, renderWhileCollapsed = false } = _a, others = __rest(_a, ["panel", "isExpanded", "closePanel", "disableContainer", "renderWhileCollapsed"]);
    // If component mounts with isExpanded = true, then it is preExpanding and should not get focus
    const [isPreExpanding, setIsPreExpanding] = React.useState(isExpanded);
    const panelWrapperRef = React.useRef(null);
    React.useEffect(() => {
        if (isPreExpanding) {
            // Once component has mounted, permanently set flag to false
            setIsPreExpanding(false);
            return;
        }
        if (panelWrapperRef.current && isExpanded && !isPreExpanding) {
            ;
            panelWrapperRef.current.querySelector('[tabindex="-1"]').focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isExpanded]);
    return isExpanded || renderWhileCollapsed ? (React.createElement(StyledAccordionItemBox, Object.assign({ disableContainer: disableContainer, "aria-hidden": !isExpanded, "$screenReaderOnly": renderWhileCollapsed && !isExpanded }, others),
        React.createElement(AccordionItemContext.Provider, { value: { isExpanded, closePanel } },
            React.createElement("div", { ref: panelWrapperRef }, panel)))) : (React.createElement(React.Fragment, null));
};
//# sourceMappingURL=AccordionItemPanelBase.js.map